import { useContext } from 'react';
import { ThemedContext } from '../context/ThemeContext.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function Image(props) {
  const {
    hoverImageId,
    darkHoverImageId,
    imageId,
    darkImageId,
    isButton = false,
    height = "auto",
    width = "auto",
    fallbackImageId,
    extension = "svg"
  } = props;
  const {
    isDark
  } = useContext(ThemedContext);
  const imgName = isDark && darkImageId ? darkImageId : imageId;
  const hoverImgName = isDark && darkHoverImageId ? darkHoverImageId : hoverImageId;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("img", {
      src: `https://images.web3auth.io/${imgName}.${extension}`,
      height: height,
      width: width,
      alt: imageId,
      className: "image-icon w3a--object-contain w3a--rounded",
      onError: ({
        currentTarget
      }) => {
        if (fallbackImageId) {
          // eslint-disable-next-line no-param-reassign
          currentTarget.onerror = null; // prevents looping
          // eslint-disable-next-line no-param-reassign
          currentTarget.src = `https://images.web3auth.io/${fallbackImageId}.svg`;
        }
      }
    }), isButton ? /*#__PURE__*/jsx("img", {
      src: `https://images.web3auth.io/${hoverImgName}.${extension}`,
      height: height,
      width: width,
      alt: hoverImageId,
      className: "hover-icon w3a--object-contain w3a--rounded"
    }) : null]
  });
}

export { Image as default };
